<template>
    <div class="details_content">
        <block-title title="基本信息" class="basic" :show-line="false">
            <a-button type="link" class="return-back" @click="handleReturnBack">返回</a-button>
            <div>
                <div class="basic-cost flex align-center">
                    <div>
                        <p>状态</p>
                        <p :class="['status', 'default', statusType(wiringInfo.status)]">
                            {{ PLANSTATUSEMU[wiringInfo.status] || '--' }}
                        </p>
                    </div>
                    <div v-if="!isPlanning" class="basic-line" />
                    <div v-if="!isPlanning">
                        <p>预估运费</p>
                        <p class="cost">￥{{ wiringInfo.transportPrice }}</p>
                    </div>
                </div>
                <a-descriptions bordered :column="3" size="small" class="wiring_desc">
                    <a-descriptions-item label="Plan文件">
                        <span v-if="wiringInfo.fileUrl">
                            {{ wiringInfo.planName }}
                            <a class="linkDownload" @click="download(wiringInfo.fileUrl, wiringInfo.planName)">下载文件</a>
                        </span>
                        <span v-else>--</span>
                    </a-descriptions-item>
                    <a-descriptions-item label="提交时间">{{ formatTime(wiringInfo.createTime) }}</a-descriptions-item>
                    <a-descriptions-item label="提交人">{{ `${wiringInfo.createUserName}${wiringInfo.createUserAccount}` }}</a-descriptions-item>
                    <a-descriptions-item label="排线规则">{{ wiringInfo.planMethod }}</a-descriptions-item>
                    <a-descriptions-item label="排线结果">
                        <span v-html="result(wiringInfo.result)" />
                    </a-descriptions-item>
                </a-descriptions>
            </div>
            <div class="active_bar">
                <div class="active_left">
                    <a-button v-if="!isPlanning && wiringInfo.status === PLAN_STATUS.TO_BE_CONFIRMED" class="confirm-btn" type="primary" @click="onConfirm">同意排线</a-button>
                    <a-button v-if="!isPlanning" @click="handlePlannedOrder(wiringInfo)">管理计划单</a-button>
                    <!-- TODO 给Planning新增“管理计划单”  -->
                    <a-button v-if="isPlanning" @click="handlePlannedOrder(wiringInfo)">管理计划单</a-button>
                    <a-button :loading="exportLoading" @click="handleExport(wiringInfo)">导出排线明细</a-button>
                    <a-button v-if="isPlanning && wiringInfo.isExistsExpenseVariance" @click="toDiffInCost(wiringInfo)">费用差申请</a-button>
                    <a-button class="confirm-btn" type="primary" :loading="createOrderLoading" :disabled="wiringInfo.status === PLAN_STATUS.CONFIRMED ? false : true" @click="confirmCreateOrder"
                        >生成订单</a-button
                    >
                </div>
                <a-button v-if="!isPlanning" type="primary" ghost @click="onSendMail">发送邮件</a-button>
            </div>
        </block-title>
        <div class="table_bar">
            <a-tabs class="ribbon-cable" type="card" @change="callback">
                <a-tab-pane v-for="item in tabsList" :key="item.key" :tab="item.lable">
                    <div class="ribbon-cable-contanier">
                        <div class="table-box">
                            <component :is="item.component" :check-tab="checkTab" :is-planning="isPlanning" :plan-code="planCode" :refresh-time="refreshTime" @refresh="handleRefresh" />
                        </div>
                        <!-- </block-title> -->
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
        <a-modal title="邮件发送确认" :visible="emailConfirmVisible" :confirm-loading="emialConfirmLoading" :z-index="1001" @ok="handleSubmitSendEmail" @cancel="handelCancelEmailConfirm">
            <div>
                <a-alert class="alert-tip" message="点击确认后，将发送邮件至下列收件人" type="warning" banner show-icon />
                <div style="margin-top: 12px;">
                    <span>{{ remindEmailUsers }}</span>
                </div>
            </div>
        </a-modal>
        <diffInCost-confirm ref="diffInCostConfirm" :is-planning="isPlanning" />
    </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue';
import moment from 'moment';
import https from '@/utils/http.js';
import HaveWiring from './component/HaveWiring.vue';
import NotWiring from './component/NotWiring.vue';
import { getPlanPage, planConfirm, sendEmail, createOrder } from '../api';
import { PLANSTATUSEMU, PLAN_STATUS } from '../list/const';
import DiffInCostConfirm from '../list/component/DiffInCostConfirm.vue';
import { getAddresseeAndContentApi } from '../../apis/email-manage';

export default {
    name: 'SmartWiringDetail',
    components: {
        BlockTitle,
        DiffInCostConfirm
    },
    props: {
        planCode: {
            type: String,
            default: ''
        }
    },
    emits: ['on-close-details'],
    data() {
        return {
            detail: {},
            PLANSTATUSEMU,
            PLAN_STATUS,
            checkTab: 'have-wiring',
            wiringInfo: {},
            isPlanning: false,
            tabsList: [
                {
                    key: 'have-wiring',
                    lable: '已排车',
                    component: HaveWiring
                },
                {
                    key: 'not-wiring',
                    lable: '待处理',
                    component: NotWiring
                }
            ],
            emailConfirmVisible: false,
            emialConfirmLoading: false, // 发送邮件loading效果
            remindEmailUsers: [], // 需要提示的邮件用户列表
            exportLoading: false,
            refreshTime: new Date(),
            createOrderLoading: false
        };
    },
    computed: {
        formatTime() {
            return (time) => moment(time).format('YYYY-MM-DD HH:mm:ss');
        },
        statusType() {
            return (status) => {
                if (status === PLAN_STATUS.TO_BE_PLAN || status === PLAN_STATUS.TO_BE_CONFIRMED) {
                    return 'await';
                }
                if (status === PLAN_STATUS.CONFIRMED) {
                    return 'success';
                }
                return '';
            };
        },
        result() {
            return (text) => {
                if (text) {
                    const splitText = text.split(',');
                    return `${splitText[0]},成功<span style="color:#06b880">${splitText[1].slice(2, -1)}</span>条,失败<span style="color:#FF523C">${splitText[2].slice(2, -1)}</span>条`;
                }
                return '--';
            };
        }
    },
    created() {
        this.getWiringInfo();
        this.isPlanning = Boolean(sessionStorage.getItem('isPlanning'));
    },
    methods: {
        async confirmCreateOrder() {
            const query = {
                planCode: this.wiringInfo.planCode
            };
            this.createOrderLoading = true;

            try {
                const res = await createOrder(query);
                if (res) {
                    this.$message.warning(`线路U单创建成功${res.successCnt || 0}条，线路U单创建失败${res.failCnt || 0}条`, 5);
                    this.createOrderLoading = false;
                }
                this.createOrderLoading = false;
                this.refreshTime = new Date();
            } catch {
                this.createOrderLoading = false;
                this.refreshTime = new Date();
            }
        },
        async confirmPlan(isConfirmPlan, resolve, resolve1) {
            const { accountName, accountId } = this.$store.state.user;
            const params = {
                planCode: this.planCode,
                isConfirmPlan,
                operateUserAccount: accountId,
                operateUserName: accountName
            };
            if (!isConfirmPlan) {
                params.isConversionPending = true;
            }
            await planConfirm(params);
            params.isConversionPending = false;
            resolve();
            if (resolve1) {
                resolve1();
            }
            this.$emit('on-close-details');
        },
        onConfirm() {
            const that = this;
            this.$confirm({
                title: '请确认排线结果',
                okText: '同意',
                cancelText: '不同意',
                onOk() {
                    return new Promise((resolve) => {
                        that.confirmPlan(true, resolve);
                    });
                },
                onCancel() {
                    return new Promise((resolve) => {
                        that.$confirm({
                            title: '请确认集散中心订单划为待处理订单列表',
                            onOk() {
                                return new Promise((resolve2) => {
                                    that.confirmPlan(false, resolve, resolve2);
                                });
                            },
                            onCancel() {
                                resolve();
                            }
                        });
                        // resolve()
                    });
                }
            });
        },
        async onSendMail() {
            try {
                const res = await getAddresseeAndContentApi({ mailCode: 'SCHEDULE_SEND' });
                this.remindEmailUsers = res?.recipientAddressStr;
                this.emailConfirmVisible = true;
            } catch (err) {
                console.log(err);
            }
        },
        // 确认发送邮件
        async handleSubmitSendEmail() {
            this.emialConfirmLoading = true;
            const { planCode, planName, fileUrl, createTime } = this.wiringInfo;
            const data = {
                planCode,
                planName,
                url: fileUrl,
                createTime: moment(createTime).format('YYYY-MM-DD HH:mm:ss')
            };
            const res = await sendEmail(data);
            if (res) {
                this.$message.warning(res);
                this.emialConfirmLoading = false;
            } else {
                this.$message.success('邮件发送成功');
                this.emailConfirmVisible = false;
                this.emialConfirmLoading = false;
            }
        },
        handelCancelEmailConfirm() {
            this.emailConfirmVisible = false;
            this.emialConfirmLoading = false;
        },
        async getWiringInfo() {
            const res = await getPlanPage({ planCode: this.planCode });
            const [row] = res.records;
            this.wiringInfo = row;
        },
        handleRefresh() {
            this.getWiringInfo();
        },
        callback(value) {
            this.checkTab = value;
        },
        download(url, fileName) {
            const x = new XMLHttpRequest();
            x.open('GET', url, true);
            x.responseType = 'blob';
            x.onload = () => {
                const csvUrl = window.URL.createObjectURL(x.response);
                const link = document.createElement('a');
                link.href = csvUrl;
                link.download = fileName;
                link.click();
            };
            x.send();
        },
        async handleExport(record) {
            this.exportLoading = true;
            await https({
                data: {
                    planCode: record.planCode,
                    planName: record.planName,
                    url: record.fileUrl,
                    isPlanDepartment: this.isPlanning
                },
                url: '/plan_msg/export',
                service: 'SMART_WIRUNG_SERVER',
                name: `${record.planName}排线`,
                type: 'xlsx'
            });
            setTimeout(() => {
                this.exportLoading = false;
            }, 1000);
        },
        handlePlannedOrder(wiringInfo) {
            this.$router.push({
                path: '/application/plannedOrderManage',
                query: {
                    planCode: wiringInfo.planCode,
                    planMethod: wiringInfo.planMethod
                }
            });
        },
        toDiffInCost(record) {
            this.$refs.diffInCostConfirm.openModal(record);
        },
        // 返回到列表
        handleReturnBack() {
            this.$emit('on-close-details');
        }
    }
};
</script>

<style lang="less" scoped>
.details_content {
    background: #f4f5f6;
    position: relative;
}
.active_bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.active_left {
    button {
        margin-right: 16px;
    }
}
.basic {
    background: #fff;
    padding: 24px 24px 32px 0;
    border-radius: 6px;
    margin-bottom: 20px;
    .confirm-btn {
        margin-right: 24px;
    }
    > div {
        padding-left: 24px;
    }
    .basic-cost {
        margin-bottom: 24px;
        margin-left: 40px;
        // img {
        //   width: 32px;
        //   height: 32px;
        //   margin-right: 12px;
        // }
        .status {
            color: #171717;
            font-weight: 500;
            font-size: 18px;
        }
        .basic-line {
            border-left: 1px solid #dcdee0;
            margin: 0 40px;
            height: 38px;
        }
        .cost {
            color: #ed4934;
            font-size: 18px;
            font-weight: 500;
        }
    }
}
.ribbon-cable {
    /deep/ &.ant-tabs-card {
        .ant-tabs-card-bar {
            height: 48px;
            margin: 0;
            .ant-tabs-nav-container {
                height: 48px;
            }
            .ant-tabs-tab {
                margin: 0;
                height: 48px;
                line-height: 48px;
                padding: 0 52px;
                border-bottom: none;
            }
        }
    }
    .ribbon-cable-contanier {
        padding: 24px 0;
        background: #ffffff;
        border-radius: 0px 6px 6px 6px;
        .table-box {
            padding: 0 24px;
        }
    }
}
.table_bar {
    position: relative;
}
.linkDownload {
    margin-left: 10px;
}
.wiring_desc {
    margin-bottom: 24px;
    /deep/.ant-descriptions-item-label {
        text-align: right;
    }
}
.export_btn {
    border: 1px solid #06b880;
    color: #06b880;
    &:hover {
        border: 1px solid #009168;
        color: #009168;
    }
}
.default {
    display: flex;
    align-items: center;
}
.default::before {
    content: '';
    width: 6px;
    height: 6px;
    display: inline-block;
    background: #ebedf0;
    border-radius: 50%;
    margin-right: 4px;
}
.success::before {
    background: #06b880;
}
.await::before {
    background: #fb9432;
}

.return-back {
    position: absolute;
    right: 10px;
    top: 10px;
}
</style>
